export const CEP_TAB_KEYS = [
  'execution-packages',
  'construction-areas',
  'work-fronts',
  'cep-progress',
  'constraints',
  'manpower',
  'equipment',
  'permits',
  'field-docs',
  'photos',
  'delays',
  'weather',
  'productivity',
  'dashboards',
  'field-ai',
  'awp',
  'digital-twin',
] as const;

export type CepTabKey = (typeof CEP_TAB_KEYS)[number];

export function isCepTabKey(tab: string | null | undefined): tab is CepTabKey {
  return !!tab && (CEP_TAB_KEYS as readonly string[]).includes(tab);
}
